import { render, staticRenderFns } from "./NitrogenRequirement.vue?vue&type=template&id=9844be26&scoped=true&lang=html&"
import script from "./NitrogenRequirement.vue?vue&type=script&lang=js&"
export * from "./NitrogenRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9844be26",
  null
  
)

export default component.exports